import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createOrReplaceAllMembershipQuestionsRequest = {};
var _createOrReplaceAllMembershipQuestionsResponse = {};
var _listAnswerCountsRequest = {};
var _listAnswerCountsResponse = {};
var _listAnswersRequest = {};
var _listAnswersResponse = {};
var _listMembershipQuestionsRequest = {};
var _listMembershipQuestionsResponse = {};
function resolveWixSocialGroupsApiV2MembershipQuestionsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/questions-proxy',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/questions-proxy',
                destPath: '',
            },
            {
                srcPath: '/_api/social-groups-proxy/questions',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups-proxy/questions',
                destPath: '',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/questions',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/questions',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/questions',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/social-groups-proxy/questions',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/questions',
                destPath: '',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/_api/social-groups-proxy/questions',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/questions',
                destPath: '',
            },
            {
                srcPath: '/social-groups-proxy/api/questions',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/social-groups-proxy/questions',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/social-groups-proxy/questions',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves the membership questions for the given group.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function listMembershipQuestions(payload) {
    var _a = serializer(_listMembershipQuestionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMembershipQuestionsResponse, {}).fromJSON;
    function __listMembershipQuestions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.membership_question',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v2.MembershipQuestionsService.ListMembershipQuestions',
            url: resolveWixSocialGroupsApiV2MembershipQuestionsServiceUrl({
                protoPath: '/v2/membership-questions/{groupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixSocialGroupsApiV2MembershipQuestionsServiceUrl({
                        protoPath: '/v2/membership-questions/{groupId}',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __listMembershipQuestions.fromReq = fromReq;
    __listMembershipQuestions.__isAmbassador = true;
    return __listMembershipQuestions;
}
/**
 * Creates membership questions if none have been set up. Otherwise, replaces all existing questions.
 * > **Notes:**
 * > * Only admins can create or replace membership questions.
 * > * Providing an empty array means that members won't have to answer any question when joining the group.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function createOrReplaceAllMembershipQuestions(payload) {
    var _a = serializer(_createOrReplaceAllMembershipQuestionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOrReplaceAllMembershipQuestionsResponse, {}).fromJSON;
    function __createOrReplaceAllMembershipQuestions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.membership_question',
            method: 'PUT',
            methodFqn: 'wix.social.groups.api.v2.MembershipQuestionsService.CreateOrReplaceAllMembershipQuestions',
            url: resolveWixSocialGroupsApiV2MembershipQuestionsServiceUrl({
                protoPath: '/v2/membership-questions/{groupId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOrReplaceAllMembershipQuestions.fromReq = fromReq;
    __createOrReplaceAllMembershipQuestions.__isAmbassador = true;
    return __createOrReplaceAllMembershipQuestions;
}
/**
 * Retrieves the answers to the membership questions, given the provided filters.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function listAnswers(payload) {
    var _a = serializer(_listAnswersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAnswersResponse, {}).fromJSON;
    function __listAnswers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.membership_question',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.MembershipQuestionsService.ListAnswers',
            url: resolveWixSocialGroupsApiV2MembershipQuestionsServiceUrl({
                protoPath: '/v2/membership-questions/{groupId}/answers',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAnswers.fromReq = fromReq;
    __listAnswers.__isAmbassador = true;
    return __listAnswers;
}
export function listAnswerCounts(payload) {
    var _a = serializer(_listAnswerCountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAnswerCountsResponse, {}).fromJSON;
    function __listAnswerCounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v2.membership_question',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v2.MembershipQuestionsService.ListAnswerCounts',
            url: resolveWixSocialGroupsApiV2MembershipQuestionsServiceUrl({
                protoPath: '/v2/membership-questions/answer-counts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAnswerCounts.fromReq = fromReq;
    __listAnswerCounts.__isAmbassador = true;
    return __listAnswerCounts;
}
//# sourceMappingURL=http.impl.js.map